<form novalidate (ngSubmit)="save()" #formClientInfo="ngForm">
    <div class="card-body mt-0 pt-4">
        <div class="row">
            <div class="col-lg-4 separator-vertical mb-4">
                <div class="form-group">
                    <label>Body Type:</label>
                    <select class="form-control form-control-solid" name="_combo_index0"
                        [(ngModel)]="petService.pet_environment.combo_index0">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of BODY_TYME">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Living Environment:</label>
                    <select class="form-control form-control-solid" name="_combo_index1"
                        [(ngModel)]="petService.pet_environment.combo_index1">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of LIVING_ENVIROMENT">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Lifestyle:</label>
                    <select class="form-control form-control-solid" name="_combo_index2"
                        [(ngModel)]="petService.pet_environment.combo_index2">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of LIFESTYLE">
                            {{ item.description }}
                        </option>

                    </select>
                </div>
                <div class="form-group">
                    <label>Tempement:</label>
                    <select class="form-control form-control-solid" name="_combo_index3"
                        [(ngModel)]="petService.pet_environment.combo_index3">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of TEMPERAMENT">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Training:</label>
                    <select class="form-control form-control-solid" name="_combo_index12"
                        [(ngModel)]="petService.pet_environment.combo_index12">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of TRAINING">
                            {{ item.description }}
                        </option>
                    </select>
                </div>

            </div>
            <div class="col-lg-4 separator-vertical mb-4">
                <div class="form-group">
                    <label>Household Population:</label>
                    <select class="form-control form-control-solid" name="_combo_index4"
                        [(ngModel)]="petService.pet_environment.combo_index4">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of HOUSEHOLD_POPULATION">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Others Pets:</label>
                    <select class="form-control form-control-solid" name="_combo_index5"
                        [(ngModel)]="petService.pet_environment.combo_index5">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of OTHER_PETS">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Coat Conditions:</label>
                    <select class="form-control form-control-solid" name="_combo_index6"
                        [(ngModel)]="petService.pet_environment.combo_index6">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of COAT_CONDITION">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Mental Conditions:</label>
                    <select class="form-control form-control-solid" name="_combo_index7"
                        [(ngModel)]="petService.pet_environment.combo_index7">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of MENTAL_CONDITION">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Training Proficiency:</label>
                    <select class="form-control form-control-solid" name="_combo_index13"
                        [(ngModel)]="petService.pet_environment.combo_index13">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of TRAINING_PROFICIENCY">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col-lg-4 mb-4">
                <div class="form-group">
                    <label>Type of Exercise:</label>
                    <select class="form-control form-control-solid" name="_combo_index8"
                        [(ngModel)]="petService.pet_environment.combo_index8">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of TYPE_EXERCISE">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Frequency of Exercise:</label>
                    <select class="form-control form-control-solid" name="_combo_index9"
                        [(ngModel)]="petService.pet_environment.combo_index9">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of FRECUENCY_EXERCISE">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Duration of Exercise:</label>
                    <select class="form-control form-control-solid" name="_combo_index10"
                        [(ngModel)]="petService.pet_environment.combo_index10">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of DURATION_EXERCISE">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Ecto Parasities:</label>
                    <select class="form-control form-control-solid" name="_combo_index11"
                        [(ngModel)]="petService.pet_environment.combo_index11">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of ECO_PARASITES">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Climate:</label>
                    <select class="form-control form-control-solid" name="_combo_index14"
                        [(ngModel)]="petService.pet_environment.combo_index14">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of CLIMATE">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

    </div>
    <div class="card-footer text-right py-lg-4">

        <button type="submit" class="btn btn-primary">
            Save Changes
        </button>
    </div>
</form>